import { render, staticRenderFns } from "./RelatedVessels.vue?vue&type=template&id=de09ffe6&"
import script from "./RelatedVessels.vue?vue&type=script&lang=js&"
export * from "./RelatedVessels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports